import { useTranslation } from 'react-i18next';

export default function Description(props) {
  var columns = [];

  const { t, i18n } = useTranslation();

  if(props.content.length != 0)
  {
    columns.push(
      <h3 className="organization__info-title">{t('informationaboutus')}</h3>
    );
  }


  return(
    <div className="organization__info organization__description">
      {columns}
      
      {(() => {
        const rawContent = props.content;
        const description = typeof rawContent === 'string'
          ? rawContent
          : (rawContent && rawContent[0] && rawContent[0].description) ? rawContent[0].description : '';
        const hasHtml = /<\/?[a-z][\s\S]*>/i.test(description);
        return hasHtml ? (
          <div dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          <div>{description}</div>
        );
      })()}
    </div>
  );
}
